<span class="time">{{ start() }}–{{ end() }}</span>
<span class="main">
    <span class="task-line">
        <span class="task">{{ task() }}</span>
        @if (state() === 'approved') {
            <i class="fa-regular fa-circle-check ui-ok" title="Goedgekeurd"></i>
        } @else if (state() === 'disapproved') {
            <i class="fa-regular fa-circle-xmark ui-error" title="Afgekeurd"></i>
        }
    </span>
    <app-client-path [client]="client()" [companyId]="companyId()" [path]="path()" colored size="sm"></app-client-path>
    <ng-content></ng-content>
</span>
